export const save_routes = "save_routes";
export const add_route = "add_route";
export const show_route = "show_route";
export const update_status = "update_status";
export const activate_routes = "activate_routes";
export const disable_routes = "disable_routes";
